import { IBatchOptions, IBatchPromiseElement, IEndpointsConfiguration } from '@kurtosys/types/api/common/index.js';
import { IRequestOptions } from '@kurtosys/types/api/IRequestOptions.js';

import { DeleteApplicationAssets } from './requests/applicationManager/DeleteApplicationAssets.js';
import { DeleteApplicationConfiguration } from './requests/applicationManager/DeleteApplicationConfiguration.js';
import { DeleteApplicationPermissions } from './requests/applicationManager/DeleteApplicationPermissions.js';
import { DeleteApplicationRole } from './requests/applicationManager/DeleteApplicationRole.js';
import { DeleteApplicationTemplateAssets } from './requests/applicationManager/DeleteApplicationTemplateAssets.js';
import { DeleteApplicationTemplatePermissions } from './requests/applicationManager/DeleteApplicationTemplatePermissions.js';
import { DeleteApplicationTemplateRole } from './requests/applicationManager/DeleteApplicationTemplateRole.js';
import { DeleteApplicationTemplateSchema } from './requests/applicationManager/DeleteApplicationTemplateSchema.js';
import { GetApplicationClientConfiguration } from './requests/applicationManager/GetApplicationClientConfiguration.js';
import { GetApplicationConfiguration } from './requests/applicationManager/GetApplicationConfiguration.js';
import { ListApplicationAssets } from './requests/applicationManager/ListApplicationAssets.js';
import { ListApplicationConfigurations } from './requests/applicationManager/ListApplicationConfigurations.js';
import { ListApplicationPermissions } from './requests/applicationManager/ListApplicationPermissions.js';
import { ListApplicationRoles } from './requests/applicationManager/ListApplicationRoles.js';
import { ListApplications } from './requests/applicationManager/ListApplications.js';
import { ListApplicationStyles } from './requests/applicationManager/ListApplicationStyles.js';
import { ListApplicationTemplateAssets } from './requests/applicationManager/ListApplicationTemplateAssets.js';
import { ListApplicationTemplatePermissions } from './requests/applicationManager/ListApplicationTemplatePermissions.js';
import { ListApplicationTemplateRole } from './requests/applicationManager/ListApplicationTemplateRole.js';
import { ListApplicationTemplates } from './requests/applicationManager/ListApplicationTemplates.js';
import { ListApplicationTemplateSchemas } from './requests/applicationManager/ListApplicationTemplateSchemas.js';
import { ListApplicationUserRoles } from './requests/applicationManager/ListApplicationUserRoles.js';
import { ListUserApplication } from './requests/applicationManager/ListUserApplication.js';
import { RetrieveApplicationAsset } from './requests/applicationManager/RetrieveApplicationAsset.js';
import { RetrieveApplicationTemplateAsset } from './requests/applicationManager/RetrieveApplicationTemplateAsset.js';
import { UpsertApplication } from './requests/applicationManager/UpsertApplication.js';
import { UpsertApplicationAsset } from './requests/applicationManager/UpsertApplicationAsset.js';
import { UpsertApplicationConfiguration } from './requests/applicationManager/UpsertApplicationConfiguration.js';
import { UpsertApplicationPermissions } from './requests/applicationManager/UpsertApplicationPermissions.js';
import { UpsertApplicationRole } from './requests/applicationManager/UpsertApplicationRole.js';
import { UpsertApplicationStyle } from './requests/applicationManager/UpsertApplicationStyle.js';
import { UpsertApplicationTemplate } from './requests/applicationManager/UpsertApplicationTemplate.js';
import { UpsertApplicationTemplateAsset } from './requests/applicationManager/UpsertApplicationTemplateAsset.js';
import { UpsertApplicationTemplatePermission } from './requests/applicationManager/UpsertApplicationTemplatePermission.js';
import { UpsertApplicationTemplateRole } from './requests/applicationManager/UpsertApplicationTemplateRole.js';
import { UpsertApplicationTemplateSchema } from './requests/applicationManager/UpsertApplicationTemplateSchema.js';
import { UpsertApplicationUserRoles } from './requests/applicationManager/UpsertApplicationUserRoles.js';
import { UpsertUserApplication } from './requests/applicationManager/UpsertUserApplication.js';
import { Initialize } from './requests/apps/Initialize.js';
import { Assurance } from './requests/auth/Assurance.js';
import { AssuranceImages } from './requests/auth/AssuranceImages.js';
import { AssuranceUpdate } from './requests/auth/AssuranceUpdate.js';
import { CreateSelfRegistrationUser } from './requests/auth/CreateSelfRegistrationUser.js';
import { Get2FAMethods } from './requests/auth/Get2FAMethods.js';
import { GetUserByToken } from './requests/auth/GetUserByToken.js';
import { Impersonate } from './requests/auth/Impersonate.js';
import { ImpersonationSearch } from './requests/auth/ImpersonationSearch.js';
import { Login } from './requests/auth/Login.js';
import { Login2FAProxy } from './requests/auth/Login2FAProxy.js';
import { LoginProxy } from './requests/auth/LoginProxy.js';
import { Logout } from './requests/auth/Logout.js';
import { LogoutProxy } from './requests/auth/LogoutProxy.js';
import { MfaDisable } from './requests/auth/MfaDisable.js';
import { MfaEnroll } from './requests/auth/MfaEnroll.js';
import { MfaEnrollAuth } from './requests/auth/MfaEnrollAuth.js';
import { MfaSettings } from './requests/auth/MfaSettings.js';
import { PasswordRequirements } from './requests/auth/PasswordRequirements.js';
import { PasswordReset } from './requests/auth/PasswordReset.js';
import { RegisterNewUser } from './requests/auth/RegisterNewUser.js';
import { RequestStrategies } from './requests/auth/RequestStrategies.js';
import { RetrieveStrategyConfig } from './requests/auth/RetrieveStrategyConfig.js';
import { SAMLSignIn } from './requests/auth/SAMLSignIn.js';
import { StopImpersonating } from './requests/auth/StopImpersonating.js';
import { UpdateOwnUser } from './requests/auth/UpdateOwnUser.js';
import { UpdatePasswordProxy } from './requests/auth/UpdatePasswordProxy.js';
import { UsernameRequest } from './requests/auth/UsernameRequest.js';
import { ValidateCode } from './requests/auth/ValidateCode.js';
import { ListCommentaries } from './requests/config/ListCommentaries.js';
import { ListDisclaimers } from './requests/config/ListDisclaimers.js';
import { ListTranslations } from './requests/config/ListTranslations.js';
import { RetrieveUserConfiguration } from './requests/config/RetrieveUserConfiguration.js';
import { SearchTranslations } from './requests/config/SearchTranslations.js';
import { UpsertUserConfiguration } from './requests/config/UpsertUserConfiguration.js';
import { DatasetDelete } from './requests/dataset/DatasetDelete.js';
import { DatasetExecuteGet } from './requests/dataset/DatasetExecuteGet.js';
import { DatasetExecutePost } from './requests/dataset/DatasetExecutePost.js';
import { DatasetGet } from './requests/dataset/DatasetGet.js';
import { DatasetList } from './requests/dataset/DatasetList.js';
import { DatasetSchemasGet } from './requests/dataset/DatasetSchemasGet.js';
import { DatasetSchemasPost } from './requests/dataset/DatasetSchemasPost.js';
import { DatasetUpsert } from './requests/dataset/DatasetUpsert.js';
import { Retrieve } from './requests/documents/Retrieve.js';
import { RetrieveDocument } from './requests/documents/RetrieveDocument.js';
import { RetrieveDocumentZip } from './requests/documents/RetrieveDocumentZip.js';
import { SearchDocuments } from './requests/documents/SearchDocuments.js';
import { SearchEntity } from './requests/fund/SearchEntity.js';
import { ConditionalMarketAnalysisBackupGet } from './requests/portal/ConditionalMarketAnalysisBackupGet.js';
import { ConditionalMarketAnalysisBackupInsert } from './requests/portal/ConditionalMarketAnalysisBackupInsert.js';
import { ConditionalMarketAnalysisBackupList } from './requests/portal/ConditionalMarketAnalysisBackupList.js';
import { ConditionalMarketAnalysisDelete } from './requests/portal/ConditionalMarketAnalysisDelete.js';
import { ConditionalMarketAnalysisGet } from './requests/portal/ConditionalMarketAnalysisGet.js';
import { ConditionalMarketAnalysisList } from './requests/portal/ConditionalMarketAnalysisList.js';
import { ConditionalMarketAnalysisUpsert } from './requests/portal/ConditionalMarketAnalysisUpsert.js';
import { ExtendedPropertyDelete } from './requests/portal/ExtendedPropertyDelete.js';
import { ExtendedPropertyGet } from './requests/portal/ExtendedPropertyGet.js';
import { ExtendedPropertyList } from './requests/portal/ExtendedPropertyList.js';
import { ExtendedPropertyUpsert } from './requests/portal/ExtendedPropertyUpsert.js';
import { ExternalApiExecute } from './requests/portal/ExternalApiExecute.js';
import { PortfolioBackupGet } from './requests/portal/PortfolioBackupGet.js';
import { PortfolioBackupInsert } from './requests/portal/PortfolioBackupInsert.js';
import { PortfolioBackupList } from './requests/portal/PortfolioBackupList.js';
import { PortfolioClone } from './requests/portal/PortfolioClone.js';
import { PortfolioDelete } from './requests/portal/PortfolioDelete.js';
import { PortfolioEntityBackupGet } from './requests/portal/PortfolioEntityBackupGet.js';
import { PortfolioEntityBackupInsert } from './requests/portal/PortfolioEntityBackupInsert.js';
import { PortfolioEntityBackupList } from './requests/portal/PortfolioEntityBackupList.js';
import { PortfolioEntityDelete } from './requests/portal/PortfolioEntityDelete.js';
import { PortfolioEntityGet } from './requests/portal/PortfolioEntityGet.js';
import { PortfolioEntityList } from './requests/portal/PortfolioEntityList.js';
import { PortfolioEntityUpsert } from './requests/portal/PortfolioEntityUpsert.js';
import { PortfolioGet } from './requests/portal/PortfolioGet.js';
import { PortfolioList } from './requests/portal/PortfolioList.js';
import { PortfolioUpsert } from './requests/portal/PortfolioUpsert.js';
import { RegimePeriodDelete } from './requests/portal/RegimePeriodDelete.js';
import { RegimePeriodGet } from './requests/portal/RegimePeriodGet.js';
import { RegimePeriodList } from './requests/portal/RegimePeriodList.js';
import { RegimePeriodUpsert } from './requests/portal/RegimePeriodUpsert.js';
import { RegimePeriodUpsertCollection } from './requests/portal/RegimePeriodUpsertCollection.js';
import { RegimeTypeDelete } from './requests/portal/RegimeTypeDelete.js';
import { RegimeTypeGet } from './requests/portal/RegimeTypeGet.js';
import { RegimeTypeList } from './requests/portal/RegimeTypeList.js';
import { RegimeTypeUpsert } from './requests/portal/RegimeTypeUpsert.js';
import { ScenarioBackupGet } from './requests/portal/ScenarioBackupGet.js';
import { ScenarioBackupInsert } from './requests/portal/ScenarioBackupInsert.js';
import { ScenarioBackupList } from './requests/portal/ScenarioBackupList.js';
import { ScenarioClone } from './requests/portal/ScenarioClone.js';
import { ScenarioDelete } from './requests/portal/ScenarioDelete.js';
import { ScenarioGet } from './requests/portal/ScenarioGet.js';
import { ScenarioGetStatistics } from './requests/portal/ScenarioGetStatistics.js';
import { ScenarioList } from './requests/portal/ScenarioList.js';
import { ScenarioManagerBackupGet } from './requests/portal/ScenarioManagerBackupGet.js';
import { ScenarioManagerBackupInsert } from './requests/portal/ScenarioManagerBackupInsert.js';
import { ScenarioManagerBackupList } from './requests/portal/ScenarioManagerBackupList.js';
import { ScenarioManagerDelete } from './requests/portal/ScenarioManagerDelete.js';
import { ScenarioManagerGet } from './requests/portal/ScenarioManagerGet.js';
import { ScenarioManagerList } from './requests/portal/ScenarioManagerList.js';
import { ScenarioManagerUpsert } from './requests/portal/ScenarioManagerUpsert.js';
import { ScenarioUpsert } from './requests/portal/ScenarioUpsert.js';
import { RawRequest } from './requests/RawRequest.js';
import { GetApplicationAppConfig } from './requests/root/GetApplicationAppConfig.js';
import { GlobalSearch } from './requests/websites/GlobalSearch.js';
import { ExportPdf } from './requests/workflow/ExportPdf.js';

export class KsysApiClient {
	token: { value: string } | undefined;
	options: IRequestOptions<any>;
	endpointsConfiguration: IEndpointsConfiguration | undefined;
	constructor(
		token: string | undefined,
		options: IRequestOptions<any>,
		endpointsConfiguration?: IEndpointsConfiguration,
	) {
		this.token = { value: token };
		this.options = options;
		this.endpointsConfiguration = endpointsConfiguration;
		this.applicationManager = {
			deleteApplicationAssets: new DeleteApplicationAssets(this.token, this.options, this.endpointsConfiguration),
			deleteApplicationConfiguration: new DeleteApplicationConfiguration(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			deleteApplicationPermissions: new DeleteApplicationPermissions(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			deleteApplicationRole: new DeleteApplicationRole(this.token, this.options, this.endpointsConfiguration),
			deleteApplicationTemplateAssets: new DeleteApplicationTemplateAssets(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			deleteApplicationTemplatePermissions: new DeleteApplicationTemplatePermissions(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			deleteApplicationTemplateRole: new DeleteApplicationTemplateRole(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			deleteApplicationTemplateSchema: new DeleteApplicationTemplateSchema(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			getApplicationConfiguration: new GetApplicationConfiguration(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			getApplicationClientConfiguration: new GetApplicationClientConfiguration(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationAssets: new ListApplicationAssets(this.token, this.options, this.endpointsConfiguration),
			listApplicationConfigurations: new ListApplicationConfigurations(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationPermissions: new ListApplicationPermissions(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationRoles: new ListApplicationRoles(this.token, this.options, this.endpointsConfiguration),
			listApplications: new ListApplications(this.token, this.options, this.endpointsConfiguration),
			listApplicationStyles: new ListApplicationStyles(this.token, this.options, this.endpointsConfiguration),
			listApplicationTemplateAssets: new ListApplicationTemplateAssets(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationTemplatePermissions: new ListApplicationTemplatePermissions(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationTemplateRole: new ListApplicationTemplateRole(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationTemplates: new ListApplicationTemplates(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationTemplateSchemas: new ListApplicationTemplateSchemas(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listApplicationUserRoles: new ListApplicationUserRoles(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			listUserApplication: new ListUserApplication(this.token, this.options, this.endpointsConfiguration),
			retrieveApplicationAsset: new RetrieveApplicationAsset(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			retrieveApplicationTemplateAsset: new RetrieveApplicationTemplateAsset(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplication: new UpsertApplication(this.token, this.options, this.endpointsConfiguration),
			upsertApplicationAsset: new UpsertApplicationAsset(this.token, this.options, this.endpointsConfiguration),
			upsertApplicationConfiguration: new UpsertApplicationConfiguration(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationPermissions: new UpsertApplicationPermissions(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationRole: new UpsertApplicationRole(this.token, this.options, this.endpointsConfiguration),
			upsertApplicationStyle: new UpsertApplicationStyle(this.token, this.options, this.endpointsConfiguration),
			upsertApplicationTemplate: new UpsertApplicationTemplate(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationTemplateAsset: new UpsertApplicationTemplateAsset(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationTemplatePermission: new UpsertApplicationTemplatePermission(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationTemplateRole: new UpsertApplicationTemplateRole(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationTemplateSchema: new UpsertApplicationTemplateSchema(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertApplicationUserRoles: new UpsertApplicationUserRoles(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			upsertUserApplication: new UpsertUserApplication(this.token, this.options, this.endpointsConfiguration),
		};
		this.apps = {
			initialize: new Initialize(this.token, this.options, this.endpointsConfiguration),
		};
		this.applications = {
			getAppConfig: new GetApplicationAppConfig(this.token, this.options, this.endpointsConfiguration),
		};
		this.auth = {
			login: new Login(this.token, this.options, this.endpointsConfiguration),
			loginProxy: new LoginProxy(this.token, this.options, this.endpointsConfiguration),
			login2FAProxy: new Login2FAProxy(this.token, this.options, this.endpointsConfiguration),
			samlSignIn: new SAMLSignIn(this.token, this.options, this.endpointsConfiguration),
			requestStrategies: new RequestStrategies(this.token, this.options, this.endpointsConfiguration),
			assurance: new Assurance(this.token, this.options, this.endpointsConfiguration),
			assuranceImages: new AssuranceImages(this.token, this.options, this.endpointsConfiguration),
			assuranceUpdate: new AssuranceUpdate(this.token, this.options, this.endpointsConfiguration),
			passwordReset: new PasswordReset(this.token, this.options, this.endpointsConfiguration),
			passwordRequirements: new PasswordRequirements(this.token, options, this.endpointsConfiguration),
			usernameRequest: new UsernameRequest(this.token, this.options, this.endpointsConfiguration),
			get2FAMethods: new Get2FAMethods(this.token, this.options, this.endpointsConfiguration),
			updatePasswordProxy: new UpdatePasswordProxy(this.token, this.options, this.endpointsConfiguration),
			validateCode: new ValidateCode(this.token, options, this.endpointsConfiguration),
			getUserByToken: new GetUserByToken(this.token, options, this.endpointsConfiguration),
			mfaEnroll: new MfaEnroll(this.token, options, this.endpointsConfiguration),
			mfaEnrollAuth: new MfaEnrollAuth(this.token, options, this.endpointsConfiguration),
			updateOwnUser: new UpdateOwnUser(this.token, options, this.endpointsConfiguration),
			mfaSettings: new MfaSettings(this.token, options, this.endpointsConfiguration),
			mfaDisable: new MfaDisable(this.token, options, this.endpointsConfiguration),
			impersonationSearch: new ImpersonationSearch(this.token, options, this.endpointsConfiguration),
			impersonate: new Impersonate(this.token, options, this.endpointsConfiguration),
			stopImpersonating: new StopImpersonating(this.token, options, this.endpointsConfiguration),
			logout: new Logout(this.token, options, this.endpointsConfiguration),
			logoutProxy: new LogoutProxy(this.token, options, this.endpointsConfiguration),
			createSelfRegistrationUser: new CreateSelfRegistrationUser(
				this.token,
				options,
				this.endpointsConfiguration,
			),
			registerNewUser: new RegisterNewUser(this.token, options, this.endpointsConfiguration),
			retrieveStrategyConfig: new RetrieveStrategyConfig(this.token, options, this.endpointsConfiguration),
		};
		this.config = {
			retrieveUserConfiguration: new RetrieveUserConfiguration(
				undefined,
				this.options,
				this.endpointsConfiguration,
			),
			upsertUserConfiguration: new UpsertUserConfiguration(undefined, this.options, this.endpointsConfiguration),
		};
		this.commentaries = {
			list: new ListCommentaries(this.token, this.options, this.endpointsConfiguration),
		};
		this.dataset = {
			get: new DatasetGet(this.token, this.options, this.endpointsConfiguration),
			delete: new DatasetDelete(this.token, this.options, this.endpointsConfiguration),
			upsert: new DatasetUpsert(this.token, this.options, this.endpointsConfiguration),
			list: new DatasetList(this.token, this.options, this.endpointsConfiguration),
			executeGet: new DatasetExecuteGet(this.token, this.options, this.endpointsConfiguration),
			executePost: new DatasetExecutePost(this.token, this.options, this.endpointsConfiguration),
			schemasGet: new DatasetSchemasGet(this.token, this.options, this.endpointsConfiguration),
			schemasPost: new DatasetSchemasPost(this.token, this.options, this.endpointsConfiguration),
		};
		this.documents = {
			search: new SearchDocuments(this.token, this.options, this.endpointsConfiguration),
			retrieve: new RetrieveDocument(this.token, this.options, this.endpointsConfiguration),
			retrieveByProperty: new Retrieve(this.token, this.options, this.endpointsConfiguration),
			retrieveZip: new RetrieveDocumentZip(this.token, this.options, this.endpointsConfiguration),
		};
		this.disclaimers = {
			list: new ListDisclaimers(this.token, this.options, this.endpointsConfiguration),
		};
		this.entity = {
			search: new SearchEntity(this.token, this.options, this.endpointsConfiguration),
		};
		this.portal = {
			conditionalMarketAnalysisDelete: new ConditionalMarketAnalysisDelete(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			conditionalMarketAnalysisGet: new ConditionalMarketAnalysisGet(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			conditionalMarketAnalysisList: new ConditionalMarketAnalysisList(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			conditionalMarketAnalysisUpsert: new ConditionalMarketAnalysisUpsert(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			conditionalMarketAnalysisBackupGet: new ConditionalMarketAnalysisBackupGet(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			conditionalMarketAnalysisBackupInsert: new ConditionalMarketAnalysisBackupInsert(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			conditionalMarketAnalysisBackupList: new ConditionalMarketAnalysisBackupList(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			extendedPropertyDelete: new ExtendedPropertyDelete(this.token, this.options, this.endpointsConfiguration),
			extendedPropertyGet: new ExtendedPropertyGet(this.token, this.options, this.endpointsConfiguration),
			extendedPropertyList: new ExtendedPropertyList(this.token, this.options, this.endpointsConfiguration),
			extendedPropertyUpsert: new ExtendedPropertyUpsert(this.token, this.options, this.endpointsConfiguration),
			externalApiExecute: new ExternalApiExecute(this.token, this.options, this.endpointsConfiguration),
			portfolioClone: new PortfolioClone(this.token, this.options, this.endpointsConfiguration),
			portfolioDelete: new PortfolioDelete(this.token, this.options, this.endpointsConfiguration),
			portfolioGet: new PortfolioGet(this.token, this.options, this.endpointsConfiguration),
			portfolioList: new PortfolioList(this.token, this.options, this.endpointsConfiguration),
			portfolioUpsert: new PortfolioUpsert(this.token, this.options, this.endpointsConfiguration),
			portfolioBackupGet: new PortfolioBackupGet(this.token, this.options, this.endpointsConfiguration),
			portfolioBackupInsert: new PortfolioBackupInsert(this.token, this.options, this.endpointsConfiguration),
			portfolioBackupList: new PortfolioBackupList(this.token, this.options, this.endpointsConfiguration),
			portfolioEntityDelete: new PortfolioEntityDelete(this.token, this.options, this.endpointsConfiguration),
			portfolioEntityGet: new PortfolioEntityGet(this.token, this.options, this.endpointsConfiguration),
			portfolioEntityList: new PortfolioEntityList(this.token, this.options, this.endpointsConfiguration),
			portfolioEntityUpsert: new PortfolioEntityUpsert(this.token, this.options, this.endpointsConfiguration),
			portfolioEntityBackupGet: new PortfolioEntityBackupGet(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			portfolioEntityBackupInsert: new PortfolioEntityBackupInsert(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			portfolioEntityBackupList: new PortfolioEntityBackupList(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			regimePeriodDelete: new RegimePeriodDelete(this.token, this.options, this.endpointsConfiguration),
			regimePeriodGet: new RegimePeriodGet(this.token, this.options, this.endpointsConfiguration),
			regimePeriodList: new RegimePeriodList(this.token, this.options, this.endpointsConfiguration),
			regimePeriodUpsert: new RegimePeriodUpsert(this.token, this.options, this.endpointsConfiguration),
			regimePeriodUpsertCollection: new RegimePeriodUpsertCollection(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			regimeTypeDelete: new RegimeTypeDelete(this.token, this.options, this.endpointsConfiguration),
			regimeTypeGet: new RegimeTypeGet(this.token, this.options, this.endpointsConfiguration),
			regimeTypeList: new RegimeTypeList(this.token, this.options, this.endpointsConfiguration),
			regimeTypeUpsert: new RegimeTypeUpsert(this.token, this.options, this.endpointsConfiguration),
			scenarioClone: new ScenarioClone(this.token, this.options, this.endpointsConfiguration),
			scenarioDelete: new ScenarioDelete(this.token, this.options, this.endpointsConfiguration),
			scenarioGet: new ScenarioGet(this.token, this.options, this.endpointsConfiguration),
			scenarioGetStatistics: new ScenarioGetStatistics(this.token, this.options, this.endpointsConfiguration),
			scenarioList: new ScenarioList(this.token, this.options, this.endpointsConfiguration),
			scenarioUpsert: new ScenarioUpsert(this.token, this.options, this.endpointsConfiguration),
			scenarioBackupGet: new ScenarioBackupGet(this.token, this.options, this.endpointsConfiguration),
			scenarioBackupInsert: new ScenarioBackupInsert(this.token, this.options, this.endpointsConfiguration),
			scenarioBackupList: new ScenarioBackupList(this.token, this.options, this.endpointsConfiguration),
			scenarioManagerDelete: new ScenarioManagerDelete(this.token, this.options, this.endpointsConfiguration),
			scenarioManagerGet: new ScenarioManagerGet(this.token, this.options, this.endpointsConfiguration),
			scenarioManagerList: new ScenarioManagerList(this.token, this.options, this.endpointsConfiguration),
			scenarioManagerUpsert: new ScenarioManagerUpsert(this.token, this.options, this.endpointsConfiguration),
			scenarioManagerBackupGet: new ScenarioManagerBackupGet(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			scenarioManagerBackupInsert: new ScenarioManagerBackupInsert(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
			scenarioManagerBackupList: new ScenarioManagerBackupList(
				this.token,
				this.options,
				this.endpointsConfiguration,
			),
		};
		this.translations = {
			list: new ListTranslations(this.token, this.options, this.endpointsConfiguration),
			search: new SearchTranslations(this.token, this.options, this.endpointsConfiguration),
		};
		this.workflow = {
			exportPdf: new ExportPdf(this.token, this.options, this.endpointsConfiguration),
		};
		this.websites = {
			globalSearch: new GlobalSearch(this.token, this.options, this.endpointsConfiguration),
		};
	}
	rawRequest<TRequestBody, TResponseBody>(
		options: IRequestOptions<TRequestBody>,
	): RawRequest<TRequestBody, TResponseBody> {
		return new RawRequest<TRequestBody, TResponseBody>(this.token, options);
	}
	updateTokenValue(token: string): void {
		if (!this.token) {
			this.token = { value: token };
		}
		this.token.value = token;
	}
	async batchExecutePromises(
		batchPromiseElements: IBatchPromiseElement[],
		passedOptions: IBatchOptions = {},
	): Promise<void> {
		const options = Object.assign({}, { maxBatchSize: this.options.maxBatchSize || 100 }, passedOptions);
		const elements: IBatchPromiseElement[] = [].concat(batchPromiseElements);
		const { maxBatchSize } = options;

		while (elements.length > 0) {
			const currentBatchSize = Math.min(elements.length, maxBatchSize);
			const currentBatch = elements.splice(0, currentBatchSize);
			const promises = currentBatch.map((element) => {
				return element.promiseFunc();
			});
			const responses = await Promise.all(promises);
			for (let i = 0; i < responses.length; i++) {
				const response = responses[i];
				const element = currentBatch[i];
				await element.responseFunc(response, element.identifier);
			}
		}
	}
	applicationManager: {
		deleteApplicationAssets: DeleteApplicationAssets;
		deleteApplicationConfiguration: DeleteApplicationConfiguration;
		deleteApplicationPermissions: DeleteApplicationPermissions;
		deleteApplicationRole: DeleteApplicationRole;
		deleteApplicationTemplateAssets: DeleteApplicationTemplateAssets;
		deleteApplicationTemplatePermissions: DeleteApplicationTemplatePermissions;
		deleteApplicationTemplateRole: DeleteApplicationTemplateRole;
		deleteApplicationTemplateSchema: DeleteApplicationTemplateSchema;
		getApplicationConfiguration: GetApplicationConfiguration;
		getApplicationClientConfiguration: GetApplicationClientConfiguration;
		listApplicationAssets: ListApplicationAssets;
		listApplicationConfigurations: ListApplicationConfigurations;
		listApplicationPermissions: ListApplicationPermissions;
		listApplicationRoles: ListApplicationRoles;
		listApplications: ListApplications;
		listApplicationStyles: ListApplicationStyles;
		listApplicationTemplateAssets: ListApplicationTemplateAssets;
		listApplicationTemplatePermissions: ListApplicationTemplatePermissions;
		listApplicationTemplateRole: ListApplicationTemplateRole;
		listApplicationTemplates: ListApplicationTemplates;
		listApplicationTemplateSchemas: ListApplicationTemplateSchemas;
		listApplicationUserRoles: ListApplicationUserRoles;
		listUserApplication: ListUserApplication;
		retrieveApplicationAsset: RetrieveApplicationAsset;
		retrieveApplicationTemplateAsset: RetrieveApplicationTemplateAsset;
		upsertApplication: UpsertApplication;
		upsertApplicationAsset: UpsertApplicationAsset;
		upsertApplicationConfiguration: UpsertApplicationConfiguration;
		upsertApplicationPermissions: UpsertApplicationPermissions;
		upsertApplicationRole: UpsertApplicationRole;
		upsertApplicationStyle: UpsertApplicationStyle;
		upsertApplicationTemplate: UpsertApplicationTemplate;
		upsertApplicationTemplateAsset: UpsertApplicationTemplateAsset;
		upsertApplicationTemplatePermission: UpsertApplicationTemplatePermission;
		upsertApplicationTemplateRole: UpsertApplicationTemplateRole;
		upsertApplicationTemplateSchema: UpsertApplicationTemplateSchema;
		upsertApplicationUserRoles: UpsertApplicationUserRoles;
		upsertUserApplication: UpsertUserApplication;
	};
	applications: {
		getAppConfig: GetApplicationAppConfig;
	};
	apps: {
		initialize: Initialize;
	};
	auth: {
		login: Login;
		loginProxy: LoginProxy;
		login2FAProxy: Login2FAProxy;
		samlSignIn: SAMLSignIn;
		requestStrategies: RequestStrategies;
		assurance: Assurance;
		assuranceImages: AssuranceImages;
		assuranceUpdate: AssuranceUpdate;
		passwordReset: PasswordReset;
		passwordRequirements: PasswordRequirements;
		usernameRequest: UsernameRequest;
		get2FAMethods: Get2FAMethods;
		updatePasswordProxy: UpdatePasswordProxy;
		validateCode: ValidateCode;
		getUserByToken: GetUserByToken;
		mfaEnroll: MfaEnroll;
		mfaEnrollAuth: MfaEnrollAuth;
		updateOwnUser: UpdateOwnUser;
		mfaSettings: MfaSettings;
		mfaDisable: MfaDisable;
		impersonationSearch: ImpersonationSearch;
		impersonate: Impersonate;
		stopImpersonating: StopImpersonating;
		logout: Logout;
		logoutProxy: LogoutProxy;
		createSelfRegistrationUser: CreateSelfRegistrationUser;
		registerNewUser: RegisterNewUser;
		retrieveStrategyConfig: RetrieveStrategyConfig;
	};
	config: {
		retrieveUserConfiguration: RetrieveUserConfiguration;
		upsertUserConfiguration: UpsertUserConfiguration;
	};
	commentaries: {
		list: ListCommentaries;
	};
	dataset: {
		get: DatasetGet;
		list: DatasetList;
		upsert: DatasetUpsert;
		delete: DatasetDelete;
		executeGet: DatasetExecuteGet;
		executePost: DatasetExecutePost;
		schemasGet: DatasetSchemasGet;
		schemasPost: DatasetSchemasPost;
	};
	documents: {
		search: SearchDocuments;
		retrieve: RetrieveDocument;
		retrieveByProperty: Retrieve;
		retrieveZip: RetrieveDocumentZip;
	};
	disclaimers: {
		list: ListDisclaimers;
	};
	entity: {
		search: SearchEntity;
	};
	portal: {
		conditionalMarketAnalysisDelete: ConditionalMarketAnalysisDelete;
		conditionalMarketAnalysisGet: ConditionalMarketAnalysisGet;
		conditionalMarketAnalysisList: ConditionalMarketAnalysisList;
		conditionalMarketAnalysisUpsert: ConditionalMarketAnalysisUpsert;
		conditionalMarketAnalysisBackupGet: ConditionalMarketAnalysisBackupGet;
		conditionalMarketAnalysisBackupInsert: ConditionalMarketAnalysisBackupInsert;
		conditionalMarketAnalysisBackupList: ConditionalMarketAnalysisBackupList;
		extendedPropertyDelete: ExtendedPropertyDelete;
		extendedPropertyGet: ExtendedPropertyGet;
		extendedPropertyList: ExtendedPropertyList;
		extendedPropertyUpsert: ExtendedPropertyUpsert;
		externalApiExecute: ExternalApiExecute;
		portfolioClone: PortfolioClone;
		portfolioDelete: PortfolioDelete;
		portfolioGet: PortfolioGet;
		portfolioList: PortfolioList;
		portfolioUpsert: PortfolioUpsert;
		portfolioBackupGet: PortfolioBackupGet;
		portfolioBackupInsert: PortfolioBackupInsert;
		portfolioBackupList: PortfolioBackupList;
		portfolioEntityDelete: PortfolioEntityDelete;
		portfolioEntityGet: PortfolioEntityGet;
		portfolioEntityList: PortfolioEntityList;
		portfolioEntityUpsert: PortfolioEntityUpsert;
		portfolioEntityBackupGet: PortfolioEntityBackupGet;
		portfolioEntityBackupInsert: PortfolioEntityBackupInsert;
		portfolioEntityBackupList: PortfolioEntityBackupList;
		regimePeriodDelete: RegimePeriodDelete;
		regimePeriodGet: RegimePeriodGet;
		regimePeriodList: RegimePeriodList;
		regimePeriodUpsert: RegimePeriodUpsert;
		regimePeriodUpsertCollection: RegimePeriodUpsertCollection;
		regimeTypeDelete: RegimeTypeDelete;
		regimeTypeGet: RegimeTypeGet;
		regimeTypeList: RegimeTypeList;
		regimeTypeUpsert: RegimeTypeUpsert;
		scenarioClone: ScenarioClone;
		scenarioDelete: ScenarioDelete;
		scenarioGet: ScenarioGet;
		scenarioGetStatistics: ScenarioGetStatistics;
		scenarioList: ScenarioList;
		scenarioUpsert: ScenarioUpsert;
		scenarioBackupGet: ScenarioBackupGet;
		scenarioBackupInsert: ScenarioBackupInsert;
		scenarioBackupList: ScenarioBackupList;
		scenarioManagerDelete: ScenarioManagerDelete;
		scenarioManagerGet: ScenarioManagerGet;
		scenarioManagerList: ScenarioManagerList;
		scenarioManagerUpsert: ScenarioManagerUpsert;
		scenarioManagerBackupGet: ScenarioManagerBackupGet;
		scenarioManagerBackupInsert: ScenarioManagerBackupInsert;
		scenarioManagerBackupList: ScenarioManagerBackupList;
	};
	translations: {
		list: ListTranslations;
		search: SearchTranslations;
	};
	workflow: {
		exportPdf: ExportPdf;
	};
	websites: {
		globalSearch: GlobalSearch;
	};
}
